export const GEL_DURATION_MINUTES = 180;
export const SMILE_RAMP_MINUTES = 10;
